import { Component, OnInit } from '@angular/core';
import { PagaresService } from '../../services/pagares.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pagares',
  templateUrl: './pagares.component.html',
  styleUrls: ['./pagares.component.scss']
})
export class PagaresComponent implements OnInit {

  // Listados y Estados
  public pagares: any[] = [];
  public kpis: any = {
    saldo_total: 0,
    total_activos: 0,
    nuevos_30_dias: 0,
    nuevos_7_dias: 0
  };
  public processing: boolean = false;

  // Filtros
  public searchFolio: string = '';
  public searchInversionista: string = '';

  // Paginación
  public paginate: any = { total_items: 0, pages: [] };
  public currentPage: number = 1;
  public pageSize: number = 10;
  public lastPage: number = 1;

  constructor(
    private pagaresService: PagaresService,
    private helperService: HelpersService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getPagares();
    this.loadKpis();
  }

  // Obtener listado dinámico de Pagarés con filtros y paginación
  public getPagares(page = 1) {
    this.processing = true;
    this.currentPage = page;

    this.pagaresService.obtenerPagares(page, this.pageSize, this.searchFolio, this.searchInversionista)
      .subscribe(response => {
        const content = response.json().content;
        this.pagares = content.data || [];
        this.lastPage = content.last_page || 1;
        this.startPaginate(content);
        this.processing = false;
      }, error => {
        this.processing = false;
        this.helperService.httpGlobalError(error);
      });
  }

  // Cargar KPIs superiores
  loadKpis() {
    this.pagaresService.getKpis().subscribe(response => {
      this.kpis = response.json().content || this.kpis;
    }, error => {
      this.helperService.httpGlobalError(error);
    });
  }

  // Aplicar filtros
  public filtrar() {
    this.getPagares(1);
  }

  // Borrar filtros
  public borrarFiltros() {
    this.searchFolio = '';
    this.searchInversionista = '';
    this.getPagares(1);
  }

  // Cambiar tamaño de elementos por página
  public changePageSize(event: any) {
    this.pageSize = Number(event.target.value);
    this.getPagares(1);
  }

  // Configuración de la paginación numérica
  startPaginate(content) {
    this.paginate = {
      current_page: content.current_page,
      last_page: content.last_page,
      total_items: content.total
    };

    const pages = [];
    for (let i = 1; i <= content.last_page; i++) {
      pages.push(i);
    }
    this.paginate.pages = pages;
  }

  goPage(page: number) {
    if (page >= 1 && page <= this.lastPage) {
      this.getPagares(page);
    }
  }

  goPreviousPage() {
    if (this.currentPage > 1) {
      this.getPagares(this.currentPage - 1);
    }
  }

  goNextPage() {
    if (this.currentPage < this.lastPage) {
      this.getPagares(this.currentPage + 1);
    }
  }

  // Navegación de acciones
  public goPerfilInversionista(inversionistaId: number) {
    this.router.navigate(['/inversionistas/perfil', inversionistaId]);
  }

  goDetallePagare(id: number): void {
    this.router.navigate(['/inversiones/pagare/detalles', id]);
  }

  public actualizarPagare(id: number) {
    this.router.navigate(['/pagares/editar', id]);
  }

  public crearPagare() {
    this.router.navigate(['/pagares/crear']);
  }
}


// WEBPACK FOOTER //
// ./src/app/inversiones/pagares/pagares.component.ts